import { Component, Schema } from "./decorators/type.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let NoLocomotionSchema = class extends Schema {
};
NoLocomotionSchema = __decorateClass([
  Component("NoLocomotion")
], NoLocomotionSchema);
const __vite_glob_0_14 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get NoLocomotionSchema() {
    return NoLocomotionSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  NoLocomotionSchema as N,
  __vite_glob_0_14 as _
};
//# sourceMappingURL=NoLocomotion-8fddd32b.js.map
